/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
/* eslint-disable @typescript-eslint/no-explicit-any */
import { ReactElement } from "react";

import {
  TransitsTableFormInput,
  TransitsTableFormInputUnit,
} from "./TransitsTableForm";

import { EditMode, EDIT_MODE } from "components/NewRouteDialog/NewRouteDialog";
import { PriceLabel } from "components/PriceLabel/PriceLabel";
import { validateNumber } from "helpers/validator";
import { SuggestedPreparedRouteDetail } from "models/suggestedPreparedRoute";

export const suggestedPreparedRouteDetailFare = (
  preparedRouteDetail: SuggestedPreparedRouteDetail
) => {
  if (
    preparedRouteDetail.initialUseCommuterPass !==
      preparedRouteDetail.useCommuterPass &&
    preparedRouteDetail.useCommuterPass
  ) {
    return 0;
  }
  return preparedRouteDetail.fare;
};

export interface FareRowProps {
  editMode: EditMode;
  suggestedPreparedRouteIndex: number;
  suggestedPreparedRouteDetail: SuggestedPreparedRouteDetail;
  preparedRouteDetailIndex: number;
  changeFare: (suggestedPreparedRouteIndex: number, fare?: number) => void;
}

export function FareRow({
  editMode,
  suggestedPreparedRouteIndex,
  suggestedPreparedRouteDetail,
  preparedRouteDetailIndex,
  changeFare,
}: FareRowProps): ReactElement | null {
  // NOTE ほぼPriceLabelと役割かぶるけど定期に関する仕様をPriceLabelに入れるか悩ましいので一旦ここで
  const renderFareLabel = () => (
    <PriceLabel
      amount={suggestedPreparedRouteDetailFare(suggestedPreparedRouteDetail)}
    />
  );

  const renderFareInput = () => (
    <>
      <TransitsTableFormInput
        className="input"
        type="number"
        value={
          suggestedPreparedRouteDetail.fare
            ? suggestedPreparedRouteDetailFare(suggestedPreparedRouteDetail)
            : ""
        }
        onChange={(event) => {
          const fare = parseInt(event.target.value, 10);
          if (validateNumber(fare)) {
            changeFare(suggestedPreparedRouteIndex, fare);
          } else {
            changeFare(suggestedPreparedRouteIndex);
          }
        }}
      />
      <TransitsTableFormInputUnit>円</TransitsTableFormInputUnit>
    </>
  );

  if (editMode === EDIT_MODE.MANUAL || editMode === EDIT_MODE.CAR_AND_BICYCLE) {
    return <>{renderFareInput()}</>;
  }
  if (editMode === EDIT_MODE.PUBLIC_TRANSPORTATION) {
    return (
      <>
        {preparedRouteDetailIndex === 0 && renderFareInput()}
        {preparedRouteDetailIndex > 0 && renderFareLabel()}
      </>
    );
  }
  return <>{renderFareLabel()}</>;
}
/* eslint-enable */
